import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
@media (prefers-reduced-motion: reduce) {
    .toast-container {
        transition: none;
    }
}
.toast-container {
    background-color: #ffffff;
    border-radius: 0;
    bottom: 60px;
    display: flex;
    padding: calc(8px * 2);
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
    transition: -webkit-transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
    font-size: 16px;
  z-index: 2;
}
.toast-text {
    display: block;
    margin: auto;
    margin-left: calc(8px + 4px);
}
.toast-container :global(.link) {
    text-decoration: none;
    color: #086ea1;
}
.toast-container.hidden {
    /* COMMENTED OUT FOR IE COMPATIBILITY for DE15870 */
    /* transform: translateY(var(--transform-y)); */
    display: none;
}
@media (min-width: 722px) {
    .toast-container {
        bottom: calc(8px * 4);
        border-radius: 5px;
        display: inline-flex;
        left: auto;
        width: 320px;
        right: calc(8px * 4);
        margin-bottom: calc(8px * 8);
    }
    .toast-container.show.push-up {
        margin-bottom: calc(8px * 24);
    }

    .toast-text {
        display: block;
        margin: auto;
        margin-left: calc(8px + 4px);
        margin-right: calc(8px + 4px);
    }

    .right-icon {
        margin-left: auto;
    }
}
`;

export default styles;